define([], () => {
  const noop = () => {};

  return {
    start: noop,
    stop: noop,
    recordEventStart: noop,
    recordEventStop: noop,
    getReport: noop,
  };
});
